import ManagerCandidatesContract from './ManagerCandidatesContract';

export default ManagerCandidatesContract;
